module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"menu":{"terms":"利用規約","reset_demo_events":"デモ用イベントを未読にする"}},"en":{"menu":{"terms":"Terms of service","reset_demo_events":"Mark demo events unviewed"}}}')
  delete Component.options._Ctor
}
